import { render, staticRenderFns } from "./server-detail.vue?vue&type=template&id=61affba2&scoped=true&"
import script from "./server-detail.vue?vue&type=script&lang=js&"
export * from "./server-detail.vue?vue&type=script&lang=js&"
import style0 from "./server-detail.vue?vue&type=style&index=0&id=61affba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61affba2",
  null
  
)

export default component.exports